import styled, { css } from 'styled-components';

const ModalWrapper = styled.div`
  [role='dialog'] {
    // Background
    & > div:first-child {
      opacity: 0.1;
    }

    // Modal
    & > div:nth-child(2) {
      max-height: calc(100% - 40px);
      margin: 0;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #3e3a83;
      border-radius: 10px;
      // Needs to have a value of auto so if the contents of the modal render
      // an infinite scroller, it gets a chance to get the scrollable element
      // (this one) to make it work properly.
      overflow: auto;

      ${(props) =>
        props.scrollableContent &&
        css`
          display: flex;
          flex-direction: column;
        `}

      // Header
      & > div:first-child {
        background-color: #f5f4fe;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;

        // Title
        & > div:first-child {
          font-size: 16px;
          letter-spacing: normal;
          text-transform: none;
        }

        // Close button
        & > button[aria-label='close'] {
          background-color: #f5f4fe;

          &:hover {
            background-color: #715aff;
          }
        }
      }

      // Content
      & > div:nth-child(2) {
        padding: ${(props) => props.contentPadding || '20px'};

        ${(props) =>
          props.scrollableContent &&
          css`
            overflow: auto;
          `}
      }

      // Footer
      & > div:nth-child(3) {
        padding: ${(props) => props.footerPadding || '20px'};
        border-top: 1px solid #d9d5f9;
        background-color: #ffffff;
      }
    }
  }
`;

export default ModalWrapper;
